import { useCallback, useMemo, useState } from "react";

import type { EcReceiptItem } from "@/lib/gql/__generated__/graphql";

import * as QueryRepository from "../repository";

import type { SearchTypeForECReceiptList } from "../constants";
import type { QueryData } from "../type";

type ReceiptIDCase = {
	receiptID: string;
};
type StartAndEndDateCase = {
	startDt: string;
	endDt: string;
};

export type OnSearchSalesMastListProps =
	| {
			receiptID: string;
	  }
	| {
			startDt: string;
			endDt: string;
	  };

type Result = {
	queryData: QueryData;

	searchType: SearchTypeForECReceiptList;
	onSetSearchType: (type: SearchTypeForECReceiptList) => void;
	freeTextSearch: string;
	onSetFreeTextSearch: (freeText: string) => void;

	// 予約の検索
	onSearchSalesMastList: (props: OnSearchSalesMastListProps) => void;
};

type Props = {
	hotelID: string;
};

export const useSearchSalesMastList = ({ hotelID }: Props): Result => {
	const [searchType, setSearchType] = useState<SearchTypeForECReceiptList>("startDtAndEndDt");
	const onSetSearchType = useCallback((type: SearchTypeForECReceiptList) => {
		setSearchType(type);
	}, []);

	const [
		/**
		 * フリーワード検索用のstate
		 */
		freeTextSearch, //
		setFreeTextSearch,
	] = useState<string>("");
	const onSetFreeTextSearch = useCallback((freeWord: string) => {
		setFreeTextSearch(freeWord);
	}, []);

	/**
	 * ローディング処理は UI で行う
	 */
	const [queryVariables, setQueryVariables] = useState<
		({ hotelID: string } & (ReceiptIDCase | StartAndEndDateCase)) | undefined
	>();
	const { queryData: queryDataForSearchByStartAndEndDate } =
		QueryRepository.useSuspenseECReceiptListByStartAndEndDate({
			queryVariables:
				queryVariables && "startDt" in queryVariables && "endDt" in queryVariables ? queryVariables : undefined,
		});
	const { queryData: queryDataForSearchByReceiptID } = QueryRepository.useSuspenseFetchEcReceiptByReceiptID({
		queryVariables: queryVariables && "receiptID" in queryVariables ? queryVariables : undefined,
	});
	const queryData = useMemo<EcReceiptItem[]>(
		() => queryDataForSearchByStartAndEndDate?.list ?? queryDataForSearchByReceiptID,
		[queryDataForSearchByReceiptID, queryDataForSearchByStartAndEndDate],
	);

	/**
	 * 収支リストの検索
	 */
	const onSearchSalesMastList = useCallback(
		(props: OnSearchSalesMastListProps) => {
			setQueryVariables({ hotelID, ...props });
		},
		[hotelID],
	);

	return {
		queryData,

		searchType,
		onSetSearchType,

		freeTextSearch,
		onSetFreeTextSearch,
		//
		// 収支リストの検索
		onSearchSalesMastList,
	};
};
